import React from "react";
import { legendItems } from "../constants/legendItems";

interface UrlaubModalProps {
  data: any[];
  onClose: () => void;
  onEdit: (event: any) => void;
}

function formatDateDMY(dateString: string) {
  const d = new Date(dateString);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}.${month}.${year}`;
}

const UrlaubModal: React.FC<UrlaubModalProps> = ({ data, onClose, onEdit }) => {
  const urlaubLegend = legendItems.find(item => item.label === "Urlaub");
  const urlaubColor = urlaubLegend ? urlaubLegend.color : "#d35400";
  const urlaubTextColor = "#fff";
  const urlaubHeaderBg = urlaubColor + "22";
  const urlaubHeaderBorder = urlaubColor + "55";

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
      onClick={onClose}
    >
      <div
        style={{
          background: "#fff",
          padding: 32,
          borderRadius: 16,
          minWidth: 320,
          maxWidth: 600,
          width: "90vw",
          maxHeight: "80vh",
          boxShadow: "0 8px 32px rgba(44,62,80,0.18)",
          overflowY: "auto"
        }}
        onClick={e => e.stopPropagation()}
      >
        <h2 style={{marginTop:0,marginBottom:24,fontWeight:700,fontSize: "1.5rem",color: urlaubColor,letterSpacing:1}}>Urlaubszeiten</h2>
        <div style={{overflowX:'auto'}}>
          <table style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: 0,
            background: "#faf9f6",
            borderRadius: 12,
            overflow: "hidden",
            boxShadow: "0 2px 8px rgba(44,62,80,0.08)"
          }}>
            <thead>
              <tr style={{background: urlaubHeaderBg}}>
                <th style={{padding: "12px 8px", textAlign: "left", fontWeight: 600, fontSize: 15, color: urlaubColor, borderBottom: `2px solid ${urlaubHeaderBorder}`}}>Titel</th>
                <th style={{padding: "12px 8px", textAlign: "center", fontWeight: 600, fontSize: 15, color: urlaubColor, borderBottom: `2px solid ${urlaubHeaderBorder}`}}>Start</th>
                <th style={{padding: "12px 8px", textAlign: "center", fontWeight: 600, fontSize: 15, color: urlaubColor, borderBottom: `2px solid ${urlaubHeaderBorder}`}}>Ende</th>
                <th style={{padding: "12px 8px", textAlign: "center", fontWeight: 600, fontSize: 15, color: urlaubColor, borderBottom: `2px solid ${urlaubHeaderBorder}`}}>Tage</th>
              </tr>
            </thead>
            <tbody>
              {data.filter(ev => ev.bgColor === urlaubColor).length === 0 ? (
                <tr><td colSpan={4} style={{ padding: 16, textAlign: "center", color: "#888" }}>Keine Urlaubstermine vorhanden.</td></tr>
              ) : (
                data
                  .filter(ev => ev.bgColor === urlaubColor)
                  .sort((a, b) => new Date(a.startTime).getTime() - new Date(b.startTime).getTime())
                  .map((ev, i) => {
                    const start = new Date(ev.startTime);
                    const end = new Date(ev.endTime);
                    // Korrigierte Berechnung: Differenz in Tagen, inkl. nur wenn Start und Ende unterschiedlich
                    const days = Math.max(1, Math.round((end.getTime() - start.getTime()) / (1000*60*60*24)));
                    return (
                      <tr
                        key={ev.id}
                        style={{
                          background: i%2===0?"#fff":"#fff7f0",
                          transition: "background 0.2s",
                          cursor: "pointer"
                        }}
                        title="Diesen Termin bearbeiten"
                        onClick={() => {
                          onClose();
                          setTimeout(() => onEdit(ev), 200);
                        }}
                        onMouseOver={e => (e.currentTarget.style.background = urlaubHeaderBg)}
                        onMouseOut={e => (e.currentTarget.style.background = i%2===0?"#fff":"#fff7f0")}
                      >
                        <td style={{ padding: "10px 8px", fontWeight: 500, textAlign: "left" }}>{ev.title}</td>
                        <td style={{ padding: "10px 8px" }}>{formatDateDMY(ev.startTime)}</td>
                        <td style={{ padding: "10px 8px" }}>{formatDateDMY(ev.endTime)}</td>
                        <td style={{ padding: "10px 8px", textAlign: "center" }}>{days}</td>
                      </tr>
                    );
                  })
              )}
            </tbody>
          </table>
        </div>
        <button
          style={{
            marginTop: 24,
            background: urlaubColor,
            color: urlaubTextColor,
            border: "none",
            borderRadius: 8,
            padding: "10px 28px",
            fontWeight: 600,
            fontSize: 16,
            cursor: "pointer",
            boxShadow: "0 2px 8px rgba(44,62,80,0.08)",
            transition: "background 0.2s"
          }}
          onClick={onClose}
          onMouseOver={e => (e.currentTarget.style.background = urlaubLegend ? urlaubLegend.color : '#a84300')}
          onMouseOut={e => (e.currentTarget.style.background = urlaubColor)}
        >Schließen</button>
      </div>
    </div>
  );
};

export default UrlaubModal;
